import 'url-search-params-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const isDevelop = process.env.NODE_ENV === 'development';

let recaptchaVerified = false;

window.certiselfSetVerifiedCallback = () => {
  recaptchaVerified = true;
  window.certiselfFormRender();
};

const recaptchaConfig = {
  getToken: () => !isDevelop && window.grecaptcha.getResponse(),
  reset: () => !isDevelop && window.grecaptcha.reset(),
  siteKey: process.env.REACT_APP_RECAPTHCA_SITE_KEY,
  verifiCallbackString: 'certiselfSetVerifiedCallback',
};

window.certiselfFormRender = () => {
  ReactDOM.render(
    <App
      recaptchaConfig={recaptchaConfig}
      recaptchaVerified={recaptchaVerified}
    />,
    document.getElementById('certiself-form')
  );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
